<div class="avia-badges">
  @if (flightTypeLabel) {
    <div class="avia-badge charter">{{ flightTypeLabel }}</div>
  }

  @if(isBestPrice) {
    <div class="avia-badge cheap">{{ translations.aviaListing.cheapest }}</div>
  }

  @if (cabinClass) {
    <div class="avia-badge class">{{ cabinClass }}</div>
  }
</div>
